import { Route } from "react-router-dom";

import ForwardContext from "../../../layouts/ForwardContext";

import ArticleRedirect from "../pages/ArticleRedirect";
import Articles from "../pages/Articles";
import ArticlesCalendar from "../pages/ArticlesCalendar";
import ArticlesTable from "../pages/ArticlesTable";

export const articles = (
	<Route path="articles" element={<ForwardContext />} handle={{ crumb: ({ t }) => t("articles", "Articles") }}>
		<Route path=":id" element={<ArticleRedirect />} />

		<Route element={<Articles />}>
			<Route index element={<ArticlesTable />} />

			<Route path="calendar" element={<ArticlesCalendar />} />
		</Route>
	</Route>
);
